import React from 'react';
import { Icon, Popover } from '@gravity-ui/uikit';
import { block } from '../utils/cn';
import { QuestionMarkIcon } from './QuestionMarkIcon';
import './HelpPopover.css';
const b = block('help-popover');
export function HelpPopover(props) {
    var _a;
    return (React.createElement(Popover, Object.assign({}, props, { className: b(null, props.className) }),
        React.createElement("button", Object.assign({ ref: props.buttonRef, type: "button" }, props.buttonProps, { className: b('button', (_a = props.buttonProps) === null || _a === void 0 ? void 0 : _a.className) }),
            React.createElement(Icon, { data: QuestionMarkIcon, size: 16 }))));
}
